import React from 'react'

import NylasCalendarConnectionFailedModal from './NylasCalendarConnectionFailedModal'

// Add any modals here that should be globally available, regardless of the user
// scope (company user, unauthenticated) or the current page
const GlobalModals: React.FC = () => (
  <>
    <NylasCalendarConnectionFailedModal />
  </>
)

export default GlobalModals
